export function resolveSelectedSchool<TSchool extends { id: string }>(
  schools: readonly TSchool[],
  requestedLocationId?: string | null,
): TSchool | null {
  const normalizedLocationId = requestedLocationId?.trim()

  if (normalizedLocationId) {
    const requestedSchool = schools.find((school) => school.id === normalizedLocationId)
    if (requestedSchool) {
      return requestedSchool
    }
  }

  return schools[0] ?? null
}
